/**
 * Payment Service
 *
 * Sends the Moneris token and payment details to the backend API
 * to complete the payment processing.
 */
import apiClient from '../api/apiClient';

export interface PaymentRequest {
  amount: string;
  currency: string;
  customerName: string;
  customerEmail: string;
  orderId: string;
  tempToken: string;
}

export interface PaymentResponse {  
  message: string;
  id?: string;
}

export async function submitPayment(payload: PaymentRequest): Promise<PaymentResponse> {
  const response = await apiClient.put<PaymentResponse>(`api/Payment/transaction/${payload.orderId}/temp-token`, payload);
  return response.data;
}
